export const naverLog = () => {
  const script1 = document.createElement("script");
  script1.src = "//wcs.naver.net/wcslog.js";
  script1.async = true;

  // 첫 번째 스크립트가 로드된 후 실행
  script1.onload = () => {
    const script2 = document.createElement("script");
    script2.type = "text/javascript";
    script2.innerHTML = `
      if (!window.wcs_add) var wcs_add = {};
      wcs_add["wa"] = "s_17ccb6c09d94";
      var _nasa = {};
      if (window.wcs) {
        _nasa["cnv"] = wcs.cnv("4", "0");
        wcs_do(_nasa);
      }
    `;
    document.body.appendChild(script2);
  };

  document.body.appendChild(script1);
};

export const naverLeadScript = () => {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = "//wcs.naver.net/wcslog.js";
  script.async = true;
  
  script.onload = () => {
    if (!window.wcs) return;
    if (!window.wcs_add) window.wcs_add = {};
    window.wcs_add['wa'] = 's_17ccb6c09d94';
    const _conv = { type: 'lead' };
    window.wcs.trans(_conv);
  };

  document.body.appendChild(script);
}
